import { foremanRoute } from '@utils/consts';
import { ProtectedRoute } from '@components/protectedRoute';
import { Outlet } from 'react-router';

import { foremanArchiveRoutes } from './archive/routes';
import { foremanOtherRoutes } from './other/routes';
import { foremanRequestsRoutes } from './requests/routes';
import { foremanSchedulesRoutes } from './schedules/routes';

export const foremanRoutes = [
  {
    path: foremanRoute.index,
    lazy: async () => ({
      Component: () => (
        <ProtectedRoute allowedRoles={['foreman']}>
          <Outlet />
        </ProtectedRoute>
      ),
    }),
    children: [
      ...foremanArchiveRoutes,
      ...foremanOtherRoutes,
      ...foremanRequestsRoutes,
      ...foremanSchedulesRoutes,
    ],
  },
];
